export default __webpack_public_path__ + "static/media/blk-design-system-pro-react.9feff8bb.jpg";